import * as React from "react";
const CrossIcon = (props) => (
  <svg
    width={35}
    height={35}
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5C0 7.83502 7.83502 0 17.5 0ZM13.5322 10.6387C12.7806 9.82964 11.5154 9.78283 10.7061 10.5342C9.89663 11.2858 9.84996 12.5519 10.6016 13.3613L14.6377 17.707L10.5859 21.7598C9.80505 22.5408 9.80494 23.8069 10.5859 24.5879C11.3669 25.3687 12.6331 25.3687 13.4141 24.5879L17.3604 20.6406L20.8799 24.4297C21.6315 25.2389 22.8967 25.2857 23.7061 24.5342C24.5153 23.7826 24.5621 22.5174 23.8105 21.708L20.1914 17.8096L24.5859 13.416C25.3668 12.635 25.3668 11.3689 24.5859 10.5879C23.8049 9.80689 22.5389 9.80698 21.7578 10.5879L17.4678 14.877L13.5322 10.6387Z"
      fill="currentColor"
    />
  </svg>
);
export default CrossIcon;
